import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
export const getActivityListTabsList = (showActivityList = true) => showActivityList ? {
    WorkOrdersPendingApproval: 0,
    LoadsPendingApproval: 1,
    PendingApprovalList: 2
} : {
    LoadsPendingApproval: 0,
    PendingApprovalList: 1
};

export const getActivityListTabs = (showActivityList = true) => {
    const activityListTabsList = getActivityListTabsList(showActivityList);
    const tabs = [
        {
            key: activityListTabsList.WorkOrdersPendingApproval,
            label: 'Work Orders Pending Approval',
        },
        {
            key: activityListTabsList.LoadsPendingApproval,
            label: 'Loads Pending Approval',
        },
        {
            key: activityListTabsList.PendingApprovalList,
            label: showActivityList ? 'Confirm Work Orders & Loads' : 'Confirm Loads',
        },
    ];
    return showActivityList ? tabs : tabs.filter(tab => tab.key !== activityListTabsList.WorkOrdersPendingApproval);
};

const ActivityListTabs = ({ selectedTab, setSelectedTab, showActivityList = true }) => {
    return (
        <TabsWrapper
            tabs={getActivityListTabs(showActivityList)}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
        />
    );
};

export default ActivityListTabs;
